import React, { useEffect, useRef, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models, powerbi } from "powerbi-client";
import { useParams } from "react-router-dom";
import preloadimg from "../../assets/img/preloader1.gif";
import $ from "jquery";
import { Alert, Button } from "react-bootstrap";
import { FaPrint } from "react-icons/fa";
import { Box, Fab } from "@mui/material";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import NavHeader from "../nav/NavHeader";
import SideMenu from "../nav/Sidemenu";
import Login from "../auth/Login";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const PowerBiReports = () => {
  const [pbireports, setPbireports] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [iserror, seterror] = useState(false);
  const [isLoaded, seteLoaded] = useState(false);
  const [PageLoading, setPageLoading] = useState(true);
  const [currentPage, setcurrentPage] = useState(0);
  const [RequestSend, setRequestSend] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const [pagename, setPageName] = useState("");
  const [pageDisplayname, setDisplyName] = useState("");
  const [open, setOpen] = useState(false);
  const [openBookmark, setopenBookmark] = useState(false);

  const [pbiPages, setPages] = useState([]);
  const { ReportID } = useParams();

  const getURl = new URL(window.location.href);
  const reportnameFetch = getURl.searchParams.get("ReportSection");
  const componentRef_1 = useRef(null);
  const [Saving, setSaving] = useState(false);
  const [removing, setRemoving] = useState(false);

  const [saveBookmarkReports, setsaveBookmarkReports] = useState([]);
  const [activeFilter, setActiveFilter] = useState(null);

  const { instance, accounts } = useMsal();

  // console.log(reportnameFetch);

  const RLtypeData = localStorage.getItem("RLTYPE");

  const passtoken =
    !localStorage.getItem("access-token-storage") ||
    localStorage.getItem("access-token-storage") === null
      ? null
      : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  const viewNotificationsReply = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const notificationID = searchParams.get("notificationiD");

    if (notificationID !== null) {
      $("#NotificationsIdValues").css("display", "block");
      $("#main").css("marginRight", "400px");
      $(`#postDataid_${notificationID}`).css("display", "block");

      const element = document.getElementById(`topic_id_${notificationID}`);
      if (element) {
        element.scrollIntoView();
      } else {
        console.error(`Element with id 'topic_id_${notificationID}' not found`);
      }
    }
  };

  useEffect(() => {
    const initialFilter = {
      $schema: "http://powerbi.com/product/schema#filter",
      target: {
        table: "Lab Selection",
        column: "Value",
      },
      operator: "In",
      values: [`${RLtypeData === "N/A" ? "RLGA" : RLtypeData}`],
      filterType: 1,
    };
    setActiveFilter(initialFilter);
  }, [RLtypeData]);

  const baseUrl = `${process.env.REACT_APP_SERVER_URL}/aipd/reports/`;

  useEffect(() => {
    const fetchSearchByname = async () => {
      await fetch(`${baseUrl}${ReportID}`, {
        headers: {
          "oidc-token": passtoken,
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((json) => {
              setPbireports(json.data);
              seterror(false);
              setIsloading(false);
              setPageLoading(false);
              const data = json.data;
              //  console.log(data.embedReport.embedToken);
              if (data.embedReport.embedToken === null) {
                seteLoaded(true);
              }
            });
          }
        })
        .catch((err) => {
          seterror(true);
          setPbireports(null);
          seteLoaded(false);
          setPageLoading(false);
          console.log("iserror");
          console.log(iserror);
        });
    };
    fetchSearchByname();
  }, [baseUrl, ReportID, iserror, passtoken]);

  const email = localStorage.getItem("myemail");

  const BookmarkURL = `${process.env.REACT_APP_SERVER_URL}/aipd/getBookmark?email=${email}`;

  useEffect(() => {
    GetBookmarkURLReports();
  }, [BookmarkURL]);

  const navigate = useNavigate();

  const logout = async () => {
    // Will redirect to MSAL to end the session then redirect back to the configured `postLogoutRedirectUri`
    try {
      // Sign out the user
      // await instance.logoutRedirect({
      //   postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`, // Replace with your redirect URI
      // });
      localStorage.clear();
      window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  useEffect(() => {
    if (passtoken === undefined || passtoken === null) {
      navigate("/");
      logout();
    }
  }, [passtoken]);

  const GetBookmarkURLReports = async () => {
    await fetch(`${BookmarkURL}`, {
      headers: {
        "oidc-token": passtoken,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            setsaveBookmarkReports(json);
          });
        }
      })
      .catch((err) => {
        setsaveBookmarkReports(null);
      });
  };

  //console.log(userInfo?.email)

  if (pbireports === null) {
    console.log("Data not available");
  }

  const embeddingData = pbireports?.embedReport;
  const EmbedUrl = embeddingData?.url;
  const Embedaccess_token = embeddingData?.embedToken;
  const EmbedPBIreport_id = `${embeddingData?.reportGuid}`;
  const PowerBiReportsName = embeddingData?.name;

  // console.log(EmbedUrl)
  const report = window.report;

  function fn(e) {
    for (var i = tooltip.length; i--; ) {
      tooltip[i].style.left = e.pageX + "px";
      tooltip[i].style.top = e.pageY + "px";
    }
  }

  if (isLoaded) {
    var tooltip;
    tooltip = document.querySelectorAll(".tooltiptext");
    document.addEventListener("mousemove", fn, false);
    viewNotificationsReply();
  }

  const embdData = (embeddedReport) => {
    window.report = embeddedReport;
    window.report.on("loaded", async function () {
      var reportPages = await window.report.getPages();
      // Function to apply filters

      report.getPages().then((pages) => {
        const indexNumber = pages.findIndex(
          (p) => p.name === `${reportnameFetch}`
        );
        const firstPage = pages[indexNumber === -1 ? 0 : indexNumber];
        const pageName = firstPage.name;
        const displayName = firstPage.displayName;
        setPageName(pageName);
        setDisplyName(displayName);
      });

      report.on("pageChanged", (event) => {
        const currentPage = event.detail.newPage;
        const pageName = currentPage.name;
        const displayName = currentPage.displayName;
        setPageName(pageName);
        setDisplyName(displayName);
      });

      report.on("dataSelected", (event) => {
        console.log("dataSelected");
      });

      window.report.getPages().then(function (pages) {
        const indexNumber = pages.findIndex(
          (p) => p.name === `${reportnameFetch}`
        );
        if (reportnameFetch !== null) {
          setcurrentPage(indexNumber + 1);
          $(`#pbiPages span:nth-child(${indexNumber + 1})`).addClass("active");
        } else {
          pages[0].setActive();
          const pageButtons = document.querySelectorAll("#pbiPages span");
          pageButtons.forEach((button) => {
            button.classList.remove("active");
          });

          // Add "active" class to the button corresponding to the first page
          const activeButton = document.querySelector(
            `#pbiPages span:first-child`
          );
          if (activeButton) {
            activeButton.classList.add("active");
          }
        }
      });

      setPages(reportPages);
      seteLoaded(true);
      trackingData();
    });
  };

  const saveReports = () => {
    setSaving(true);
    setopenBookmark(false);
    const email = localStorage.getItem("myemail");

    const data = [
      {
        reportId: parseInt(ReportID),
        pagename: `${pagename}`,
        title: `${pageDisplayname}`,
      },
    ];

    const url = `${process.env.REACT_APP_SERVER_URL}/aipd/saveBookmarks?email=${email}`;
    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 201) {
          // console.log(response);
          GetBookmarkURLReports();
          setSaving(false);
          toast.success(
            `${decodeURIComponent(pageDisplayname)} Added Successfully`,
            {
              // Set to 15sec
              position: toast.POSITION.BOTTOM_LEFT,
              autoClose: 6000,
            }
          );
        }
      })
      .catch(function (error) {
        console.log(error);
        alert("Error");
        setSaving(false);
      });
  };

  const removeBookmark = () => {
    setRemoving(true);
    setOpen(false);
    const deleteUrl = `${process.env.REACT_APP_SERVER_URL}/aipd/deleteBookmark?email=${email}`;
    axios
      .delete(deleteUrl, {
        headers: {
          "oidc-token": passtoken,
        },
        data: {
          reportId: parseInt(ReportID),
          pagename: `${pagename}`,
          title: `${pageDisplayname}`,
        },
      })
      .then((response) => {
        setRemoving(false);
        GetBookmarkURLReports();
        toast.success(
          `${decodeURIComponent(
            pageDisplayname
          )} Bookmark Removed Successfully`,
          {
            // Set to 15sec
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 6000,
          }
        );
      })

      .catch((error) => {
        alert("Error deleting resource:", error);
      });
  };

  const downloadReportAsPDF = async () => {
    report.print().catch((error) => {
      console.log(error);
    });
  };

  const Trackingrl = `${process.env.REACT_APP_SERVER_URL}/aipd/tracking`;

  const trackingData = () => {
    const header = {
      headers: {
        "oidc-token": passtoken,
      },
    };

    const data = {
      reportId: parseInt(ReportID),
      userGroupId: parseInt(localStorage.getItem("userGroup")),
    };

    axios
      .post(Trackingrl, data, header)
      .then(function (response) {
        if (response.status === 200) {
          console.log("Tracking in progress ...");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const onreploadPage = () => {
    console.log("reload");
  };

  // console.log(currentPage);

  const activeCurrentPage = async (e) => {
    // var reportPages = await window.report.getPages();
    //         reportPages[currentPage].setActive();
    var target = e.target;
    var parent = target.parentNode;
    var index = [].indexOf.call(parent.children, target);
    // $(this).addClass("active").siblings().removeClass("active");
    // setcurrentPage(index);
    var reportPages = await window.report.getPages();
    reportPages[index].setActive();

    // console.log(target);
  };

  return (
    <div>
      <>
        {PageLoading && (
          <>
            <NavHeader onclickmenu={false} />
            <SideMenu />
          </>
        )}

        {!PageLoading && (
          <>
            <NavHeader
              title={pageDisplayname}
              guid={EmbedPBIreport_id}
              reportId={ReportID}
              pageName={pagename}
              onclickmenu={Embedaccess_token !== null ? true : false}
              onreploadPage={onreploadPage}
              pageLoad={Embedaccess_token !== null ? isLoaded : false}
            />
            <SideMenu
              activeCurrentPage={(e) => activeCurrentPage(e)}
              setcurrentPage={setcurrentPage}
              id={ReportID}
              pages={pbiPages}
              name={Embedaccess_token !== null ? "PowerBINav" : ""}
              activeIndexData={currentPage}
              reportnameFetch={reportnameFetch || null}
              Embedaccess_token={Embedaccess_token}
            />
          </>
        )}
        <div id="main">
          <div style={{ height: "100%", position: "relative" }}>
            {!isLoaded && (
              <div
                style={{
                  position: "absolute",
                  background: "white",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  zIndex: 9999999,
                }}
                className="pageLoading"
              >
                <div
                  style={{
                    position: "fixed",
                    background: "rgba(0,0,0,0.8)",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    display: "grid",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    zIndex: "99999",
                    justifyItems: "center",
                    alignContent: "center",
                  }}
                >
                  <img width={200} src={preloadimg} alt="Loading" />
                  <span>Report is loading, please wait...</span>
                </div>
              </div>
            )}

            {!isLoading && !iserror && Embedaccess_token !== null && (
              <div style={{ position: "relative", height: "100%" }}>
                {isLoaded && (
                  <>
                    {/* <Button
                    style={{
                      position: "absolute",
                      right: "-35px",
                      top: "-30px",
                      background: "white",
                      color: "#a3172f",
                      border: "none",
                    }}
                    onClick={downloadReportAsPDF}
                  >
                    <FaPrint />
                  </Button> */}

                    {/* {saveBookmarkReports.some(
                    (item) => item.pagename === pagename
                  ) ? (
                    // Render the bookmark added button when pageName matches
                    <Box className="floatingButtonHome">
                      <Fab
                        className="floatingButton"
                        color="primary"
                        style={{ position: "fixed", right: "40px", zIndex: 0 }}
                        aria-label="add"
                        onClick={() => setOpen(!open)}
                      >
                        <BookmarkAddedIcon sx={{ color: "white" }} />
                      </Fab>
                    </Box>
                  ) : (
                    // Render the original button when pageName does not match
                    <Box className="floatingButtonHome">
                      <Fab
                        onClick={() => setopenBookmark(!openBookmark)}
                        className="floatingButton"
                        color="primary"
                        style={{ position: "fixed", right: "40px", zIndex: 0 }}
                        aria-label="add"
                      >
                        <StarBorderIcon />
                      </Fab>
                    </Box>
                  )} */}

                    {/* <ChatRoomNew title={pageDisplayname} guid = {EmbedPBIreport_id}/> */}
                  </>
                )}

                <PowerBIEmbed
                  embedConfig={{
                    type: "report", // Supported types: report, dashboard, tile, visual, and qna.
                    id: EmbedPBIreport_id,
                    embedUrl: EmbedUrl,
                    accessToken: Embedaccess_token,
                    //pageName: 'ReportSectione5bc25aa0357c917eaaa',
                    pageName: `${
                      reportnameFetch === null ? "" : reportnameFetch
                    }`,
                    tokenType: models.TokenType.Embed, // Use models.TokenType.Aad if you're embedding for your organization.
                    permissions: models.Permissions.All,
                    viewMode: models.ViewMode.View,

                    settings: {
                      navContentPaneEnabled: false,
                      filterPaneEnabled: true,
                      persistentFiltersEnabled: true,

                      bars: {
                        actionBar: {
                          visible: true,
                        },
                        statusBar: {
                          visible: false,
                        },
                      },
                      panes: {
                        filters: {
                          expanded: false,
                          visible: true,
                        },
                      },
                    },
                  }}
                  eventHandlers={
                    new Map([
                      [
                        "loaded",
                        async function () {
                          console.log("Report loaded");
                        },
                      ],

                      ["dataSelected", function (event) {}],

                      [
                        "rendered",
                        async function () {
                          // console.log("Report rendered");
                          // var reportPages = await window.report.getPages();
                          // setPbireports(reportPages)
                        },
                      ],
                      [
                        "error",
                        function (event) {
                          // console.log(event.detail);
                        },
                      ],
                    ])
                  }
                  cssClassName={"report-style-class"}
                  getEmbeddedComponent={embdData}
                />
              </div>
            )}

            {!isLoading && Embedaccess_token === null && (
              <div className="reportView_pbi">
                <Alert variant="danger">
                  Powerbi access token is expired please check after sometime
                </Alert>
              </div>
            )}

            {iserror && <div>There is some error Please try again later </div>}

            {Saving && (
              <div
                style={{
                  position: "fixed",
                  background: "rgba(0,0,0,0.8)",
                  width: "100%",
                  height: "100%",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  zIndex: "99999",
                  justifyItems: "center",
                  alignContent: "center",
                }}
              >
                <img width={200} src={preloadimg} alt="Loading" />
                <span>Adding your bookmark...</span>
              </div>
            )}

            {removing && (
              <div
                style={{
                  position: "fixed",
                  background: "rgba(0,0,0,0.8)",
                  width: "100%",
                  height: "100%",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  zIndex: "99999",
                  justifyItems: "center",
                  alignContent: "center",
                }}
              >
                <img width={200} src={preloadimg} alt="Loading" />
                <span>Removing your bookmark...</span>
              </div>
            )}

            <Dialog
              open={open}
              onClose={() => setOpen(!open)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle
                style={{
                  background: "#A70E13",
                  color: "#fff",
                  fontWeight: "500",
                }}
                id="alert-dialog-title"
              >
                {"This page is already bookmarked!!"}
              </DialogTitle>
              <DialogContent style={{ marginTop: "16px" }}>
                <DialogContentText id="alert-dialog-description">
                  Do you wish to remove the bookmark?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  className="submit_btn"
                  style={{ width: "auto" }}
                  onClick={removeBookmark}
                  autoFocus
                >
                  Yes
                </Button>

                <Button
                  className="cancel_btn"
                  style={{ width: "auto" }}
                  onClick={() => setOpen(!open)}
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openBookmark}
              onClose={() => setopenBookmark(!openBookmark)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle
                style={{
                  background: "#A70E13",
                  color: "#fff",
                  fontWeight: "500",
                }}
                id="alert-dialog-title"
              >
                {"A bookmark will be successfully established for this page"}
              </DialogTitle>
              <DialogContent style={{ marginTop: "16px" }}>
                <DialogContentText id="alert-dialog-description">
                  Please confirm to bookmark this page
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  className="submit_btn"
                  style={{ width: "auto" }}
                  onClick={saveReports}
                  autoFocus
                >
                  Yes
                </Button>

                <Button
                  className="cancel_btn"
                  style={{ width: "auto" }}
                  onClick={() => setopenBookmark(!openBookmark)}
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>

            <ToastContainer />
          </div>
        </div>
      </>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default PowerBiReports;
